<template>
  <div>
    <Header/>
    <section class="section">
      <div class="container">
        <div class="columns is-centered has-text-centered">
          <div class="column is-half">
            <h1 class="title section-title is-size-1">Gallery</h1>
            <p class="is-size-3">
              Click on thumbnail to view full-size photos.
            </p>
            <p>
              If you have any photos of Yiqing you like, we
              would love to share them in this gallery. Please
              <a href="mailto:rememberyiqingweb+photos@gmail.com">email</a>
              the images to us to be put on the website.
            </p>
            <p class="is-5 text-ch">
              如果您愿意分享和伊青有关的照片，请发送至这个
              <a href="mailto:rememberyiqingweb+photos@gmail.com">电子邮箱</a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <ImageGallery />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import ImageGallery from '@/components/ImageGallery.vue';

export default {
  name: 'Gallery',
  components: {
    Header,
    ImageGallery,
  },
};
</script>
